import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import SuccessModal from "../SuccessModal";
import { canceledOrder } from "../../services/CancelOrder/canceledOrder";
import { Checkbox } from "primereact/checkbox";
import { refundOrder } from "../../services/OrderDelivery/deliveryOrder";
import { getStoreLocalData } from "../../utils/localStorage";

export default function RefundAmountAdminModal({
  refundModalVisible,
  setRefundModalVisible,
  storeId,
  storeCustomerId,
  bookingOrderId,
  storeUserId,
  balanceAmount,
  orderInfoDetails,
  updateOrderGarmentInfoPage,
}) {
  const navigate = useNavigate();

  const [remarkValue, setRemarkValue] = useState("");
  const [remarkError, setRemarkError] = useState("");

  const { storeLocalData } = getStoreLocalData();

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const [
    isCheckedRefundAmountUserAccount,
    setIsCheckedRefundAmountUserAccount,
  ] = useState(true);

  const [isReceivePaymentButtonPressed, setIsReceivePaymentButtonPressed] =
    useState(false);

  const [paymentMethodRefundValue, setPaymentMethodRefundValue] =
    useState("USER_ACCOUNT");

  const handleModalClose = () => {
    setRefundModalVisible(false);
  };

  const handleConfirmAndContinue = () => {
    if (!isReceivePaymentButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsReceivePaymentButtonPressed(true);

      const refundData = {
        storeCustomerId: storeCustomerId,
        storeId: storeId,
        orderId: bookingOrderId,
        refundBy: storeUserId,
        amount: -balanceAmount,
        paymentMode: paymentMethodRefundValue,
        paymentRefNo: "",
      };

      refundOrder(storeId, refundData)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            setModalVisible(true);
            setModalStatus(Res.status === true ? "success" : "unsuccess");
            setModalText(Res.message);
            if (Res.status) {
              const timer = setTimeout(() => {
                setRefundModalVisible(false);
                updateOrderGarmentInfoPage({
                  info: true,
                });
              }, 1500);
              return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
            }
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    }
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={refundModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!refundModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-2 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <i
                className="pi pi-cart-minus"
                style={{ fontSize: "50px", color: "#fff" }}
              ></i>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Refund
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
            <div className="inline-flex flex-column gap-2 mx-4">
              <InputText
                value={remarkValue}
                onChange={(e) => setRemarkValue(e.target.value)}
                id="Remark"
                label="Remark"
                placeholder="Remark"
                className="w-full bg-white-alpha-20 border-round-lg px-3 text-md "
              ></InputText>
            </div>
            <div>
              <p className="text-xl font-normal mx-4" style={{ color: "red" }}>
                {remarkError}
              </p>
            </div>

            <div>
              <div className="mx-4 mb-1">
                <div className="w-full flex px-4 h-3rem  text-2xl border-round-xl shadow-2 justify-content-start align-items-center">
                  <p className="text-xl font-normal" style={{ color: "#666" }}>
                    Return Balance Amount
                  </p>
                  <p
                    className="text-xl font-normal ml-2"
                    style={{ color: "#000" }}
                  >
                    {" (" + storeLocalData?.currencySymbol + " " + -balanceAmount + ") "}
                  </p>
                </div>
              </div>
              <div className="mx-4 my-2">
                <div className="flex justify-content-between align-items-center">
                  <div className="w-full flex px-4 h-3rem  text-2xl border-round-xl shadow-2 justify-content-between align-items-center">
                    <p
                      className="text-xl font-normal"
                      style={{ color: "#000" }}
                    >
                      User Account
                    </p>
                    <div className="flex justify-content-start align-items-center">
                      <Checkbox
                        size={15}
                        checked={isCheckedRefundAmountUserAccount}
                        color={
                          isCheckedRefundAmountUserAccount
                            ? "#00A3FF"
                            : "#C1C9D3"
                        }
                        onClick={() => {
                          setIsCheckedRefundAmountUserAccount(
                            !isCheckedRefundAmountUserAccount
                          );
                          if (!isCheckedRefundAmountUserAccount) {
                            setPaymentMethodRefundValue("USER_ACCOUNT");
                          } else {
                            setPaymentMethodRefundValue("USER_ACCOUNT");
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="flex flex-1 flex-row  py-2 sticky z-2 bottom-0 w-full"
                style={{ backgroundColor: "white" }}
              >
                <div className="flex-1 flex-row mx-4 mb-1 gap-2">
                  <Button
                    className="p-2 w-full text-2xl border-1 flex justify-content-center uppercase"
                    style={{
                      color: "#fff",
                      backgroundColor: "#2B70D7",
                      borderRadius: 5,
                    }}
                    onClick={() => handleConfirmAndContinue()}
                    disabled={isReceivePaymentButtonPressed}
                  >
                    Refund
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
}
